import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import { motion } from 'framer-motion'
import SVG from 'react-inlinesvg'
import { StoreButton } from '../StoreButton/StoreButton'
import { useStoresToDisplay } from 'hooks/useStoresToDisplay'
import { StoreIcon } from '../../types/locale'

const StyledWrapper = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
`

const StyledStoresContainer = styled.div`
  display: flex;
  gap: 24px;
`
type NavProps = {
  logo: string
  storesIcons: StoreIcon[]
}
export const Nav = ({ logo, storesIcons }: NavProps) => {
  const stores = useStoresToDisplay(storesIcons)

  return (
    <StyledWrapper>
      <Link to="/" aria-label="Go to home page">
        <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 1.1 }}>
          <SVG src={logo} />
        </motion.div>
      </Link>
      <StyledStoresContainer>
        {stores.map(({ id, link, icon }) => (
          <StoreButton key={id} icon={icon} link={link} />
        ))}
      </StyledStoresContainer>
    </StyledWrapper>
  )
}
